import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../constants/enums";
import {
  APP_FILE_BEFORE_CREATE,
  APP_FILE_BINDER_LIST,
  APP_FILE_CERTIFICATE_OF_INSURANCE,
  APP_FILE_INSURANCE_REPORTS_TAB,
  APP_FILE_OLD_BUSINESS_TRACKER,
  APP_FILE_OLD_INSURANCE_REPORTS_LIST,
  APP_FILE_RENEWAL_LIST,
  APP_FILE_REQUESTED_USER_NAME,
  APP_FILE_TASK_ADD_MARKETING,
  APP_FILE_TASK_BINDER_LIST,
  APP_FILE_TASK_BOARD,
  APP_FILE_TASK_CALENDER,
  APP_FILE_TASK_MARKETINGS_LIST,
  APP_FILE_VIEW_TASK_DETAILS,
} from "./Tasks.constants";

const BeforeCreate = Loadable(
  lazy(() =>
    import("./BeforeCreate/BeforeCreate").then(({ BeforeCreateTask }) => ({
      default: BeforeCreateTask,
    }))
  )
);
const OldBusinessTracker = Loadable(
  lazy(() =>
    import("./BeforeCreate/OldBusinessTracker").then(
      ({ OldBusinessTracker }) => ({
        default: OldBusinessTracker,
      })
    )
  )
);
const ViewTaskDetails = Loadable(
  lazy(() =>
    import("./ViewTaskDetails/ViewTaskDetailsLayout").then(
      ({ ViewTaskDetailsLayout }) => ({
        default: ViewTaskDetailsLayout,
      })
    )
  )
);
// const CreateTasks = Loadable(
//   lazy(() =>
//     import("./CreateTask/CreateTask").then(({ CreateTask }) => ({
//       default: CreateTask,
//     }))
//   )
// );
const InsuranceReport = Loadable(
  lazy(() =>
    import("./InsuranceReports/InsurnceReportsTabs/InsuraceReportsTabs").then(
      ({ InsuraceReportsTabs }) => ({
        default: InsuraceReportsTabs,
      })
    )
  )
);
const OldInsuranceReportsList = Loadable(
  lazy(() =>
    import("./InsuranceReports/OldInsuranceReportsList").then(
      ({ OldInsuranceReportsList }) => ({
        default: OldInsuranceReportsList,
      })
    )
  )
);
// const OrderInsuranceReport = Loadable(
//   lazy(() =>
//     import("./InsuranceReports/OrderInsuranceReport").then(
//       ({ OrderInsuranceReport }) => ({
//         default: OrderInsuranceReport,
//       })
//     )
//   )
// );
// const NoPolicyInsuranceReports = Loadable(
//   lazy(() =>
//     import("./InsuranceReports/NoPolicyInsuranceReports/NoPolicyInsuranceReports").then(
//       ({ NoPolicyInsuranceReports}) => ({
//         default: NoPolicyInsuranceReports,
//       })
//     )
//   )
// );
const TaskBoard = Loadable(
  lazy(() =>
    import("./TaskBoard/TasksBoard").then(({ TaskBoard }) => ({
      default: TaskBoard,
    }))
  )
);
const TaskCalenderTabs = Loadable(
  lazy(() =>
    import("./TaskCalender/TaskCalendertabs").then(({ TaskCalenderTabs }) => ({
      default: TaskCalenderTabs,
    }))
  )
);
const RenewalListTabs = Loadable(
  lazy(() =>
    import("./Renewal/RenewalListTab").then(({ RenewalListTabs }) => ({
      default: RenewalListTabs,
    }))
  )
);

const ManageMyRenewals = Loadable(
  lazy(() =>
    import("./Renewal/ManageMyRenewalsList").then(({ ManageMyRenewals }) => ({
      default: ManageMyRenewals,
    }))
  )
);
const TaskBinderList = Loadable(
  lazy(() =>
    import("./Binder/Binder").then(({ TaskBinderList }) => ({
      default: TaskBinderList,
    }))
  )
);
const BinderList = Loadable(
  lazy(() =>
    import("./Binder/BinderList").then(({ BinderList }) => ({
      default: BinderList,
    }))
  )
);
const TaskMarketingsList = Loadable(
  lazy(() =>
    import("./MarketingList/MarketingTabs").then(
      ({ MarketingTabs }) => ({
        default: MarketingTabs,
      })
    )
  )
);
const Marketing = Loadable(
  lazy(() =>
    import("./MarketingList/Marketing").then(({ Marketing }) => ({
      default: Marketing,
    }))
  )
);
const RequestedUserName = Loadable(
  lazy(() =>
    import("./RequestedUserName/RequestedUserName").then(
      ({ RequestedUserName }) => ({
        default: RequestedUserName,
      })
    )
  )
);
const CertificateOfInsuranceList = Loadable(
  lazy(() =>
    import("./CertificateOfInsuranceList/CertificateOfInsuranceList").then(
      ({ CertificateOfInsuranceList }) => ({
        default: CertificateOfInsuranceList,
      })
    )
  )
);
export const taskRoutes = [
  {
    path: `${APP_FILE_BEFORE_CREATE}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ALL_TASK]}>
        <BeforeCreate />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_OLD_BUSINESS_TRACKER}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.OLD_BUSINESS_TRACKER]}>
        <OldBusinessTracker />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_VIEW_TASK_DETAILS}/:taskCode`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ALL_TASK]}>
        <ViewTaskDetails />
      </AuthorizedRoute>
    ),
  },
  // {
  //        path: `${APP_FILE_CREATE_TASKS}`,
  //        exact: true,
  //        element: (
  //          <AuthorizedRoute moduleKeys={[MODULE_IDS.ALL_TASK]}>
  //            <CreateTasks />
  //          </AuthorizedRoute>
  //        ),
  //      },

  //      {
  //        path: `${APP_FILE_CREATE_TASKS}/:taskCode`,
  //        exact: true,
  //        element: (
  //          <AuthorizedRoute moduleKeys={[MODULE_IDS.ALL_TASK]}>
  //            <CreateTasks />
  //          </AuthorizedRoute>
  //        ),
  //      },
  {
    path: `${APP_FILE_INSURANCE_REPORTS_TAB}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.INSURANCE_REPORTS]}>
        <InsuranceReport />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_OLD_INSURANCE_REPORTS_LIST}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.OLD_INSURANCE_REPORTS]}>
        <OldInsuranceReportsList />
      </AuthorizedRoute>
    ),
  },
  // {
  //   path: `${APP_FILE_ORDER_INSURANCE_REPORT}`,
  //   exact: true,
  //   element: (
  //     <AuthorizedRoute moduleKeys={[MODULE_IDS.INSURANCE_REPORTS]}>
  //       <OrderInsuranceReport />
  //     </AuthorizedRoute>
  //   ),
  // },
  // {
  //   path: `${APP_FILE_NO_POLICY_INSURANCE_REPORT}`,
  //   exact: true,
  //   element: (
  //     <AuthorizedRoute moduleKeys={[MODULE_IDS.INSURANCE_REPORTS]}>
  //       <NoPolicyInsuranceReports />
  //     </AuthorizedRoute>
  //   ),
  // },
  {
    path: `${APP_FILE_TASK_BOARD}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_TASKBOARD]}>
        <TaskBoard />
      </AuthorizedRoute>
    ),
  },

  {
    path: `${APP_FILE_TASK_CALENDER}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.ALL_TASK]}>
        <TaskCalenderTabs />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_RENEWAL_LIST}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_RENEWALS]}>
        <RenewalListTabs />
      </AuthorizedRoute>
    ),
  },
   {
    path: `${APP_FILE_RENEWAL_LIST}/my-renewals/manage/:code`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_RENEWALS]}>
        <ManageMyRenewals />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_TASK_BINDER_LIST}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_BINDERS]}>
        <TaskBinderList />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_BINDER_LIST}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_BINDERS]}>
        <BinderList />
      </AuthorizedRoute>
    ),
  },
  {
          path: `${APP_FILE_TASK_MARKETINGS_LIST}`,
          exact: true,
          element: (
            <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_MARKETING]}>
              <TaskMarketingsList />
            </AuthorizedRoute>
          ),
        },
        {
          path: `${APP_FILE_TASK_ADD_MARKETING}`,
          exact: true,
          element: (
            <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_MARKETING]}>
              <Marketing />
            </AuthorizedRoute>
          ),
        },
        {
          path: `${APP_FILE_REQUESTED_USER_NAME}`,
          exact: true,
          element: (
            <AuthorizedRoute moduleKeys={[MODULE_IDS.ALL_TASK]}>
              <RequestedUserName />
            </AuthorizedRoute>
          ),
        },
        {
          path: `${APP_FILE_CERTIFICATE_OF_INSURANCE}`,
          exact: true,
          element: (
            <AuthorizedRoute allowFullAccess moduleKeys={[]}>
              <CertificateOfInsuranceList />
            </AuthorizedRoute>
          ),
        },
];
//moduleKeys={[MODULE_IDS.TASK_CERTIFICATE_OF_INSURANCE]}